import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@pancakeswap/uikit/dist/theme'

import DMSansReg from '../assets/fonts/DMSans-Regular.woff2'
import DMSansBold from '../assets/fonts/DMSans-Bold.woff2'
import DMSansMed from '../assets/fonts/DMSans-Medium.woff2'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  
  @font-face {
    font-family: 'DM Sans';
    src: local('DM Sans'), url(${DMSansReg}) format('woff2');
  }

  @font-face {
    font-family: 'DM Sans';
    font-weight: 700;
    src: local('DM Sans'), url(${DMSansBold}) format('woff2');
  }

  @font-face {
    font-family: 'DM Sans';
    font-weight: 500;
    src: local('DM Sans'), url(${DMSansMed}) format('woff2');
  }

  
  * {
    font-family: 'DM Sans', sans-serif;
    ::-webkit-scrollbar-thumb {
      background-color: #FFFFFF;
    }
    ::-webkit-scrollbar {
      width: 3px;
    }
  }
  body {
    background: rgba(30, 31, 32, 0.8);
    overflow-x: hidden;
    
    #token-search-input {
      :focus {
        filter: drop-shadow(0px 0px 8px #DAA10E);
        box-shadow: none;
      }
    }
    #token-search-input::-webkit-input-placeholder {
      color: rgba(255, 255, 255, 0.6);
    }
    input[type="text"]::-webkit-input-placeholder {
      color: #ffffff;
    }

    img {
      height: auto;
      max-width: 100%;
    }
    [role="presentation"] {
      background: rgba(30, 31, 32, 0.95);
    }
    [role="presentation"] + div {
      background: rgba(30, 31, 32, 0.95);
      border: 1px solid #DAA10E;
      [color="text"] {
        color: #DAA10E;
      }
    }
    .sc-gIvpjk {
      background: #1E1F20;
      border-bottom: 1px solid #DAA10E;
      h2 {
        color: #DAA10E;
      }
    }
    [href="https://docs.pancakeswap.finance/get-started/connection-guide"] {
      display: none;
    }

    /* develop */
    .WFckb{
      fill: #DAA10E;
    }
    .fJYfpH {
      border-bottom: none;
    }
    .hZurtV {
      display: none;
    }
    .bGARoH {
      background: transparent;
      border: 1px solid #DAA10E;
    }
    /* prod */
    .ACFFk{
      fill: #DAA10E;
    }
    .ezMVWK {
      border-bottom: none;
    }
    .lgkSXZ {
      display: none;
    }
    .hdzOgI {
      background: transparent;
      border: 1px solid #DAA10E;
    }
  }
`

export default GlobalStyle
